// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__2Klic","label":"Category_label__2FfV-","content":"Category_content__3nDvB","header":"Category_header__17XDw","location":"Category_location__3Ez9o"};